import { IIconProps } from "../types"

export default function IconUL7(props: IIconProps) {
  const width = props.size || props.width || (93 / 5) * 3
  const height = props.size || props.height || (95 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 93 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.4806 0.849213C53.4122 0.389361 47.3242 0.299389 41.3961 0.719255C35.468 1.14912 29.6998 2.07882 25.5612 3.29843C21.4325 4.52803 18.9333 6.05754 16.5541 8.80666C14.1848 11.5558 11.9455 15.5345 9.50632 21.3226C7.07709 27.1208 4.44794 34.7383 2.86844 40.0267C1.29895 45.315 0.78911 48.274 0.56918 52.7226C0.339254 57.1612 0.409232 63.0793 1.04903 67.8677C1.68882 72.6462 2.90843 76.285 4.28799 79.7939C5.65755 83.3128 7.19706 86.6917 8.99648 89.0609C10.7859 91.4302 12.8452 92.7897 15.1145 93.4195C17.3938 94.0593 19.893 93.9694 23.032 93.4195C26.171 92.8697 29.9598 91.85 34.9282 90.8004C39.8866 89.7407 46.0446 88.6411 50.5931 88.6811C55.1517 88.721 58.0907 89.9107 60.5599 90.9203C63.0292 91.94 65.0185 92.7897 67.4577 92.6998C69.887 92.6098 72.776 91.6001 75.5951 89.8207C78.4142 88.0413 81.1733 85.5121 83.8025 81.4434C86.4317 77.3847 88.9309 71.7965 90.4704 66.3882C91.9999 60.9699 92.5797 55.7216 91.8099 49.6336C91.0402 43.5355 88.9309 36.5978 86.6216 29.8699C84.3123 23.1421 81.8131 16.6342 79.2839 12.1856C76.7448 7.747 74.1856 5.37776 70.8866 3.76828C67.5777 2.15879 63.549 1.31906 58.4806 0.849213Z"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
        strokeDasharray="1.8 2.7"
      />
    </svg>
  )
}
